<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-filter-param-date-range-input
      [fc]="form.get('date')"
      baseFilterItem
      [label]="'Date'"
      (rangeSelected)="dateSelected($event)"
    ></ifc-filter-param-date-range-input>
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Initiator</mat-label>
      <input matInput formControlName="initiator" type="text" placeholder="Initiator name" />
      <button
        type="button"
        *ngIf="form.controls.initiator.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.initiator.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ng-container *ngIf="form.get('date').value === 'custom'">
      <ifc-datepicker [fc]="form.get('dateFrom')" [label]="'From date'" [max]="maxDateFrom" baseFilterItem></ifc-datepicker>

      <ifc-datepicker [fc]="form.get('dateTo')" [label]="'To date'" [min]="minDateTo" baseFilterItem></ifc-datepicker>
    </ng-container>

    <ifb-audit-trial-event-input [fc]="form.get('event')" baseFilterItem></ifb-audit-trial-event-input>
  </ifc-base-filter-dialog>
</form>
